import React from "react";
import { useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { VariationDto } from "@intelligems/ig-types";
import { Grid, GridProps, ListItemButton } from "@mui/material";

import { selectedVariations } from "../../../store/slices/variations";
import { VariationFe } from "../../../types/schemas/variations";

interface VariationButtonsProps extends GridProps {
  selectedTestGroup: string | undefined;
  setSelectedTestGroup: (value: string | undefined) => void;
  selectedCard: (id: string) => boolean;
  rootClass: string;
  variations: VariationDto[];
}

export const VariationButtons = ({
  selectedTestGroup,
  setSelectedTestGroup,
  selectedCard,
  rootClass,
  sx,
  variations,
}: VariationButtonsProps) => {
  return (
    <Grid container spacing={2} direction={"row"} sx={sx}>
      {variations.map((variation) => {
        return (
          <Grid item key={variation.id} xs={6}>
            <ListItemButton
              aria-labelledby={variation.name}
              onClick={() => {
                if (selectedTestGroup === variation.id)
                  setSelectedTestGroup(undefined);
                else {
                  setSelectedTestGroup(variation.id);
                }
              }}
              selected={selectedCard(variation.id!)}
              classes={{ root: rootClass }}
            >
              <IgTypography variant="body1" sx={{ fontWeight: 600 }}>
                {variation.name}
              </IgTypography>
            </ListItemButton>
          </Grid>
        );
      })}
    </Grid>
  );
};
